/**
 * An enumeration of all apex site feature modules.
 */
export const SiteModuleEnum = {
    ApplicationAdministration: 1,
    TimeEntry: 2,
    Roster: 3,
    Payroll: 4,
    RsScheduling: 8,
    ShowLocations: 14,
    SalesTeams: 15,
    Users: 16,
    Commission: 17,
    Reports: 18, // Mainly ADP Reports.
    Auditing: 19,
    Invoicing: 20,
    Financials: 21,
    Onboarding: 22,
    Leads: 23,
    ProgramAdministration: 24,
    Payout: 25,
    RogersReports: 26,
    EventsCoordination: 27,
    EventsScheduling: 28
};
